/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Recommendations {
    getFixupPrototypeFunction() { return Recommendations.fixupPrototype; }

    static newInstance(model: Partial<Recommendations>): Recommendations {
        let obj = Object.assign(new Recommendations(), model);
        Recommendations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Recommendations>): Recommendations {
        if (!model) return null;
        return Recommendations.newInstance(<Recommendations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Recommendations) {
        if (!obj) return;

        models.Recommendations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Recommendations): boolean {
        Object.setPrototypeOf(obj, Recommendations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.quantity === undefined) {
            this.quantity = 0;
        }
        if (this.estimated_cost_savings === undefined) {
            this.estimated_cost_savings = 0;
        }
    }

    /**
     * Tenant Name
     */
    tenant_name: string;

    /**
     * Cloud Account Name
     */
    cloud_account_name: string;

    /**
     * Reservation type
     */
    reservation_type: string;

    /**
     * Reservation SKU Details
     */
    reservation_sku: string;

    /**
     * Region
     */
    region: string;

    /**
     * Quantity
     */
    quantity: number;

    /**
     * How much cost is saved based on recommendation suggested
     */
    estimated_cost_savings: number;

    /**
     * Cloud Account ID
     */
    cloud_account_id: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Cloud Service
     */
    service: string;

    /**
     * Information
     */
    info: string;

    /**
     * Saving Percentage
     */
    savings_percentage: string;

}
